import { useSearchParams } from 'react-router-dom';

export const useGetQueryParams = () => {
  const [searchParams] = useSearchParams();
  return (paramName) =>
    searchParams.has(paramName) ? +searchParams.get(paramName) : undefined;
};
